import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import { Button } from '../../../../helbest';

const CartFooter = ({ login, isEmpty }) => {
  const history = useHistory();

  return (
    <div className="page-cart-footer">
      <Button
        onClick={() => {
          if (isEmpty) {
            history.push('/');
            return;
          }
          if (!login.is_login) history.push('/login/p/');
          else history.push(login.is_login ? '/delivery/' : '/login/c/');
        }}>
        {isEmpty ? 'مشاهده محصولات' : 'انتخاب شیوه ارسال'}
      </Button>
    </div>
  );
};

CartFooter.propTypes = {
  login: PropTypes.object
};

const mapStateToProps = (state) => ({
  login: state.Login
});

export default connect(mapStateToProps)(CartFooter);
